<template>
  <div>
    <el-form 
      role="form" 
      @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input 
            v-uppercase 
            v-model="serviceCategory.label" 
            label="Name"/>
          <base-input 
            v-uppercase 
            v-model="serviceCategory.letter" 
            label="Initial Letter"/>
        </div>
      </div>
      <base-button 
        md 
        type="primary" 
        native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("serviceCategory", ["serviceCategory"]),
    ...mapGetters({
      serviceCategoryList: "serviceCategory/getServiceCategoryList",
    }),
  },

  methods: {
    ...mapActions({
      saveServiceCategory: "serviceCategory/saveServiceCategory",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      updateServiceCategory: "serviceCategory/updateServiceCategory"
    }),

    duplicateMessage() {
      const label = (this.serviceCategory.label || "").trim().toLowerCase();
      const letter = (this.serviceCategory.letter || "").trim().toLowerCase();
      const currentId = this.serviceCategory.serviceCategoryId;
      const others = (this.serviceCategoryList || []).filter(
        (row) => row.serviceCategoryId !== currentId
      );
      if (label && others.some((row) => (row.label || "").trim().toLowerCase() === label)) {
        return "A service category with this name already exists.";
      }
      if (letter && others.some((row) => (row.letter || "").trim().toLowerCase() === letter)) {
        return "This initial letter is already used.";
      }
      return "";
    },
    notifySaveError(err) {
      const details =
        err && err.response && err.response.data && err.response.data.details;
      if (Array.isArray(details) && details.length) {
        details.forEach((item) => {
          this.$notify({
            message: item.message,
            type: "danger",
            title: "Validation Error",
          });
        });
        return;
      }
      this.$notify({
        message: "Could not save.",
        type: "danger",
        title: "Error",
      });
    },
    onSubmit() {
      const duplicate = this.duplicateMessage();
      if (duplicate) {
        this.$notify({
          message: duplicate,
          type: "danger",
          title: "Validation Error",
        });
        return;
      }
      if (this.serviceCategory.serviceCategoryId) {
        this.updateServiceCategory().then(res => {
          this.$notify({
            message: "Service Category Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getServiceCategoryList();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      } else {
        this.saveServiceCategory().then(res => {
          this.$notify({
            message: "Service Category Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getServiceCategoryList();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      }
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
  }
};
</script>